import Cards from "../../../Cards/Cards";
import AccentTitle from "../AccentTitle/AccentTitle";
import classes from "./WorkList.module.scss";
import Tooltip from '../../../Tooltip/tooltip';
const data = [
  {
    number: "a.",
    title: "Внедрили\n систему SEO-шаблонизаторов для карточек товаров",
  },
  {
    number: "b.",
    title: <>Создали систему независимого тегирования <span className={classes.TooltipWrap}>любых страниц <Tooltip text="Здесь должен быть контент"/></span></>,
  },
  {
    number: "c.",
    title: "Разработали систему автоматического ресайза изображений для снижения их «веса»",
  },
  {
    number: "d.",
    title: "Внедрили систему автоматической установки тегов ALT для изображений",
  },
  {
    number: "e.",
    title: "Внедрили нестандартные коды отслеживания различных параметров и целей для различных статистических систем и систем ретаргетинга",
  },
  {
    number: "f.",
    title: "Создали большой пул новых страниц под высокочастотные запросы и так далее",
  },
]

const WorkList = () => {
  return (
    <div className={classes.WorkList}>
      <div className={classes.Wrapper}>
        <AccentTitle
          customClass={classes.Title}
          title={"Техническая поддержка"}
          number={"01."}
          text={<>В рамках технических работ было сделано огромное количество правок касающихся, как контента <Tooltip text="Текст"/>  сайта, так и всей функциональности сайта. Наша поддержка работала в режиме 24*7, часто внося правки в сайт в выходные дни. Кроме этого поддержка постоянно выполняла работы по рекомендациям SEO-специалистов, за это время мы:</>}
        />
        {data.map((elem, i) => {
          return (
            <Cards
              customClass={classes.Item}
              customTitleClass={classes.CardsTitle}
              number={elem.number}
              title={elem.title}
              text={elem.text}
              key={i}
              />
          )
        })}
      </div>
      <div className={classes.Footer}>
        <p className={classes.Bold}>
        Кроме этого в рамках сотрудничества с нами был разработан сложнейший личный кабинет для дилеров ГК Топол Эко.
        </p>
      </div>
    </div>
  )

}

export default WorkList;